import React, { Dispatch, SetStateAction, useMemo } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'

import { fieldsMessages } from 'components/Fields/messages'
import { ClaimDeviceInputControlContainer } from '../styles'
import {
  ClaimDeviceManuallyFormWrapper,
  ClaimDevicePrimaryButton,
  ClaimDeviceTextField,
} from './styles'

interface ManualDeviceFormData {
  mac: string
  code: string
}

interface initialManualDeviceDataProps {
  setDeviceDataCode: Dispatch<SetStateAction<string>>
  setDeviceDataMac: Dispatch<SetStateAction<string>>
}

const initialManualDeviceData: ManualDeviceFormData = { code: '', mac: '' }

//TODO: Localization
function ClaimDeviceManuallyForm({
  setDeviceDataCode,
  setDeviceDataMac,
}: initialManualDeviceDataProps) {
  const { formatMessage } = useIntl()

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        mac: Yup.string()
          .trim()
          .required(formatMessage(fieldsMessages.requiredField)),
        code: Yup.string()
          .trim()
          .required(formatMessage(fieldsMessages.requiredField)),
      }),
    [formatMessage]
  )

  const submitManualDeviceFormData = ({ code, mac }: ManualDeviceFormData) => {
    setDeviceDataCode(code.replaceAll('-', '').toUpperCase())
    setDeviceDataMac(mac.replaceAll(':', '').toLowerCase())
  }

  return (
    <Formik
      initialValues={initialManualDeviceData}
      onSubmit={submitManualDeviceFormData}
      validationSchema={validationSchema}
    >
      <ClaimDeviceManuallyFormWrapper>
        <ClaimDeviceInputControlContainer>
          <ClaimDeviceTextField name="mac" placeholder="MAC" showLabel />
          <ClaimDeviceTextField name="code" placeholder="Code" showLabel />
        </ClaimDeviceInputControlContainer>

        <ClaimDevicePrimaryButton variant="primary" type="submit">
          Claim
        </ClaimDevicePrimaryButton>
      </ClaimDeviceManuallyFormWrapper>
    </Formik>
  )
}

export default ClaimDeviceManuallyForm
